"use client"

import { BLXApplications } from "config/routing"
import type React from "react"
import { selectActiveBrandId, useAppSelector } from "services"
import { useMMBRouteNavigationLinkItems } from "utils/routeBuilders/mmb/useMMBRouteNavigationLinkItems"

import { VStack } from "@chakra-ui/react"

import { NavLinkItem } from "./components"
import AppNavigationContainer from "./components/AppNavigationContainer"
import NavigationAccordion from "./components/NavigationAccordion"

/*
// TODO: ENG-2114 - Implement with Hypertune
const marketingAccordionItems = (brandId: string) => [
    { label: 'Analytics', links: marketingAnalyticsConfig(brandId) },
    { label: 'settings', links: marketingSettingsConfig(brandId) },
]
*/

const MarketingNavigation: React.FC = () => {
    const activeBrandId = useAppSelector(selectActiveBrandId)

    const { mmbApplicationNavigationConfig } = useMMBRouteNavigationLinkItems()

    const navDisabled = !activeBrandId || activeBrandId.length <= 0

    return (
        <AppNavigationContainer app={BLXApplications.Marketing}>
            <VStack gap={0} w='full'>
                {mmbApplicationNavigationConfig.map((navLinktItem, i) => (
                    <NavLinkItem
                        item={navLinktItem}
                        key={navLinktItem.application + i}
                        disabled={navDisabled}
                    />
                ))}
            </VStack>
            <NavigationAccordion accordionItems={[]} disabled={navDisabled} />
        </AppNavigationContainer>
    )
}

export default MarketingNavigation
